/* globals CSS_CONFIG */
import {
  sendMessageToParent,
  getTargetOrigins,
} from './helpers/postMessageHelper';
import { getQueryParamsFromURL } from './helpers/urlHelper';
import type { AppView } from './types/app';

interface EventDataPayload {
  questionsToken?: string;
  orderNo?: string;
  appointmentId?: string;
  startTime?: string;
  endTime?: string;
  locationType?: string;
  serviceId?: string;
}

export type EventName =
  | 'BOKA/BOKA_CLOSED'
  | 'BOKA/BOOKING_COMPLETE'
  | 'BOKA/QUESTIONS_ANSWERED'
  | 'BOKA/QUESTIONS_CLOSED';

const isApprovedDataTarget = (): boolean => {
  const { refApp } = getQueryParamsFromURL();
  if (!refApp) return false;
  return CSS_CONFIG.approvedDataTargets.includes(refApp);
};

export const sendEventToParent = (
  eventName: EventName,
  view: AppView,
  data?: EventDataPayload,
): void => {
  if (window.parent === window) return;

  const payload = isApprovedDataTarget() ? data : undefined;

  // Prefer pubsub if available in the parent frame.
  // Accessing window.parent.* on a cross-origin frame throws a SecurityError;
  // optional chaining does not prevent this, so we guard with try/catch.
  try {
    if (window.parent.ikea?.pubsub?.publish) {
      window.parent.ikea.pubsub.publish(eventName, payload);
      return;
    }
  } catch {
    // Cross-origin frame — pubsub not accessible, fall through to postMessage
  }

  if (view === 'alt' && getTargetOrigins().length > 0) {
    console.log('Sending event to parent - event:', eventName);
    sendMessageToParent(
      eventName,
      payload as Record<string, string | undefined>,
    );
  }
};
